import { useQuery } from '@tanstack/react-query'
import { useAtomValue } from 'jotai'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { exists } from '~/utils'

import { surveyIdAtom } from '../../atoms'

const document = graphql(`
  query SurveyFilterInformation_SurveyFilters($surveyId: ID!) {
    surveyFilters(surveyId: $surveyId) {
      id
      title
    }
  }
`)

import { useSurveyFiltersQueryKey } from './useSurveyFiltersQueryKey'

export const useSurveyFiltersQuery = () => {
  const graphQLRequest = useGraphQLRequest()
  const queryKey = useSurveyFiltersQueryKey()
  const surveyId = useAtomValue(surveyIdAtom)

  return useQuery({
    enabled: exists(surveyId),
    queryFn: () => graphQLRequest({ document, variables: { surveyId } }),
    queryKey,
  })
}
